<template>
    <div>
        <div ref="trigger">
        <slot>
            <ui-button 
                :disabled="disabled"
                icon="directions_car" 
                style="width: 100%; margin-bottom: .5rem; justify-content: left;"
            >Vehicle</ui-button>
        </slot>
        </div>
        <ui-popover ref="assignPopover" :trigger="$refs.trigger" v-show="!disabled">
            <div style="width:100%; background:#f8f8f8; padding: .8rem 1rem;">Vehicle</div>
            <div style="padding: 1rem; width: 30rem;">
                <vehicle-selector v-model="selected" :allow-addition="false" :show-clear-vehicle="false" :status="newJobInstanceStatus"></vehicle-selector>
                <ui-button :loading="isLoading" @click="save">Save</ui-button>
                <ui-button v-show="selected.id" :disabled="isLoading" @click="destroy" color="red">Remove</ui-button>
            </div>
        </ui-popover>
    </div>
</template>

<script>
    import { VehicleInstanceSchema, VehicleLifeCycleStatuses } from '../../../classes/Api/Vehicle'
    import VehicleSelector from '../controls/KeenVehiclePicker'

    export default {
        components: { VehicleSelector },
        props: {
            isLoading: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            instance: {},
            disabled: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            id: {
                default() {
                    return Math.random();
                }
            },
            taskType: {
                type: String
            }
        },
        mounted() {
            if (this.instance) {
                this.selected = this.instance
            }
        },
        watch: {
            instance: {
                handler: function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.selected = (newVal === null ? {} : newVal);
                    }
                },
                deep: true,
            }
        },
        data() {
            return {
                selected: {},
            }
        },
        methods: {
            save() {
                this.$emit('save', Object.assign({}, this.selected));
            },
            destroy() {
                this.$emit('save', new VehicleInstanceSchema());
            },
            reset() {
                this.$refs['assignPopover'].close();
            },
            show() {
                this.$refs.assignPopover.open()
            }
        },
        computed: {
            newJobInstanceStatus() {
                if ('job' === this.taskType) {
                    return [
                        VehicleLifeCycleStatuses.IN_STOCK,
                        VehicleLifeCycleStatuses.DUE_IN,
                        VehicleLifeCycleStatuses.RESERVED,
                        VehicleLifeCycleStatuses.AWAITING_DELIVERY
                    ]
                }

                return []
            },
        }
    }
</script>